import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-photo-gallery',
  templateUrl: './add-photo-gallery.component.html',
  styleUrls: ['./add-photo-gallery.component.css']
})
export class AddPhotoGalleryComponent implements OnInit {

  arr = [{
    show: false, showLoader: false, deleteImage: false
  }]
  showImage = false
  photoarr: any = [];
  photoarr1: any = [];
  photoLimit = 6;
  arrObj: any = [];
  dummyError = [12, 3, 4, 5, 6, 7]
  baseUrl = environment.basePath;
  loading = false;

  constructor(
    private authService: AuthenticationService,
    public router: Router) { }


  ngOnInit(): void {
    this.getPhotoGallery()
  }

  getPhotoGallery() {
    this.loading = true;
    this.authService.onphotoGallery().subscribe((res: any) => {

      this.photoarr = res.data.images;
      this.photoarr1 = this.photoarr;
      this.photoLimit = res.data.photoLimit;
      this.loading = false;
    },
      (error: any) => {
        console.log(error);
        this.loading = false;
      })
  }

  uploadImage(event: any) {
    if (this.photoarr.length >= this.photoLimit) {
      this.authService.successMessage(`You can only upload up to ${this.photoLimit} images.`, 'error');
      return;
    }

    const file = event.target.files[0];

    if (!file) {
      this.authService.successMessage('Please select an image to upload.', 'error');
      return;
    }

    // Validate file type (only images)
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      this.authService.successMessage('Invalid file type. Please select a JPG, PNG, or WEBP image.', 'error');
      return;
    }

    // Validate file size (max 2MB)
    const maxSizeInMB = 2;
    if (file.size / 1024 / 1024 > maxSizeInMB) {
      this.authService.successMessage(`File size exceeds ${maxSizeInMB}MB. Please select a smaller image.`, 'error');
      return;
    }

    const formData = new FormData();
    formData.append('image', file, file.name);
    formData.append('imageType', 'profilePic');

    this.authService.upload(formData).subscribe(
      (data: any) => {
        const url = data?.data?.url;
        if (url) {
          this.arrObj.push(url);
          this.photoarr.push(url);
        }
      },
      (error: any) => {
        const msg = error?.error?.message || 'Something went wrong while uploading. Please try again.';
        this.authService.successMessage(msg, 'error');
      }
    );
  }

  renderImage(e: any) {
    if (e !== undefined || e !== null) {
      const [baseUrl, imgUrl] = e.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
    }
  }


  deleteImage(i: any) {
    if (this.photoarr.length == 0) return
    this.photoarr.splice(i, 1)
  }



  onSubmit() {
    if (this.photoarr.length == 0) {
      return
    }
    this.authService.updatePhotoGallery({ imagePath: this.photoarr }).subscribe((res: any) => {
      if (res.code == 200) {
        this.authService.successMessage('Photo gallery has been saved', 'success')
        this.router.navigate(["/photo-gallery"]);
      }
    },
      (error: any) => {
        this.authService.successMessage(error.error.message, 'error')
      }
    )
  }


  backDashboard() {
    this.photoarr = this.photoarr1;
    this.router.navigate(["/photo-gallery"]);
  }

}
